export default __webpack_public_path__ + "static/media/chatBubbleIcon.94a7abf6.svg";